import { useContext } from "react";
import { BuyerRelationshipDeliveryEstimateContext } from "./BuyerRelationshipDeliveryEstimateContext";

export const useBuyerRelationshipDeliveryEstimate = () => {
  const context = useContext(BuyerRelationshipDeliveryEstimateContext);

  if (!context) {
    throw new Error(
      "useBuyerRelationshipDeliveryEstimate must be used within a BuyerRelationshipDeliveryEstimateProvider",
    );
  }

  return context;
};
